export const state = {
  allInvoices: [],
  activePage: 1,
  totalRows: 0,
  totalPages: 0,
  loadingInvoices: false,
};
